module.exports = __webpack_public_path__ + "montserrat-regular-webfont.905df5ed2d20dcd226be.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/src/assets/fonts/montserrat-regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-regular-webfont.woff2
// module chunks = 1